/** @jsx jsx */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import '../Home.css';
import SSRf from 'orbiter-web/lib/SSR';
import { jsx } from '@emotion/core';
import FullScreenImage from 'orbiter-web-components/src/components/fullScreenImage/FullScreenImage';
import { Container, Row, Col } from 'react-bootstrap';
import { contentContainerStyling, containerStyling, ColStyling, contentStyling, contentLogoStyling, sectionTitleStyling } from '../homeCSS';
import TopCard from 'orbiter-web-components/src/components/card/TopCard';
class Domotica extends React.Component {
    static loadServerData(props) {
        return __awaiter(this, void 0, void 0, function* () {
            const q = __non_webpack_require__('orbiter-core/src/MongoDatabaseConnection');
            const dbConn = yield q.default();
            const collection = yield dbConn.getCollection('sections');
            let title = yield collection.findOne({ strid: 'domotica titel' });
            title = title.content.NL;
            let content = yield collection.findOne({ strid: 'domotica inhoud' });
            content = content.content.NL;
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve({
                        domotica: { title, content },
                    });
                }, 500);
            });
        });
    }
    constructor(a) {
        super(a);
    }
    render() {
        if (this.props.domotica === undefined) {
            return null;
        }
        return (jsx(FullScreenImage, { onClick: this.props.onClick, contentContainerStyle: contentContainerStyling, backgroundImage: "/images/backgrounds/domotica.jpg", nextPageImage: "/images/arrowButtons/arrowBottom.svg" },
            jsx(Container, { css: containerStyling },
                jsx(Row, null,
                    jsx(Col, { md: 12, css: ColStyling },
                        jsx(TopCard, { imageSrc: "/images/icons/smart-house-phone-power-1.svg", titleStyle: (t) => [sectionTitleStyling(t), this.props.colorCombination(t)], cardStyle: contentStyling, imageStyle: contentLogoStyling, title: this.props.domotica.title, center: true },
                            jsx("div", { css: this.props.colorCombination, dangerouslySetInnerHTML: { __html: this.props.domotica.content } })))))));
    }
}
export default SSRf(Domotica);
//# sourceMappingURL=Domotica.js.map